import React from 'react';
import { Link } from 'react-router-dom';

const PADAD010 = ({ userData }) => {
    return (
        <div className="register-container">
            {/* Content Register */}
            <div id="register-complete" className="content-wrap">
                <img src="./images/PADAD010/congratulations.png" alt="congratulations" />
                <h1>
                    <b>회원가입</b>이 완료되었습니다.
                </h1>
                <span>{userData?.nameKor}님, 통합회원가입이 완료되었습니다.</span>
                <span>로그인 후 좀 더 다양한 서비스를 이용해보세요.</span>
                <p>※ 회원가입 내역 확인 및 수정은 마이 페이지 &gt; 회원정보 수정에서 가능합니다.</p>
                <div className="button-group">
                    <Link to="/login" className="button button-blue border-radius-10 border-1-ddd">
                        로그인
                    </Link>
                    <Link to="/" className="button button-white border-radius-10 width-120">
                        메인 페이지
                    </Link>
                </div>
            </div>
            {/* End Content Register */}
        </div>
    );
};

export default PADAD010;
